/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PtwCloudCalibrationDataDto } from './PtwCloudCalibrationDataDto';
import {
    instanceOfPtwCloudCalibrationDataDto,
    PtwCloudCalibrationDataDtoFromJSON,
    PtwCloudCalibrationDataDtoFromJSONTyped,
    PtwCloudCalibrationDataDtoToJSON,
} from './PtwCloudCalibrationDataDto';

/**
 * @type CalibrationDataOverviewDtoNewDownloadedCalibration
 * 
 * @export
 */
export type CalibrationDataOverviewDtoNewDownloadedCalibration = PtwCloudCalibrationDataDto;


export function CalibrationDataOverviewDtoNewDownloadedCalibrationFromJSON(json: any): CalibrationDataOverviewDtoNewDownloadedCalibration {
    return CalibrationDataOverviewDtoNewDownloadedCalibrationFromJSONTyped(json, false);
}

export function CalibrationDataOverviewDtoNewDownloadedCalibrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalibrationDataOverviewDtoNewDownloadedCalibration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...PtwCloudCalibrationDataDtoFromJSONTyped(json, true) };
    return  PtwCloudCalibrationDataDtoFromJSONTyped(json, true);
}

export function CalibrationDataOverviewDtoNewDownloadedCalibrationToJSON(value?: CalibrationDataOverviewDtoNewDownloadedCalibration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfPtwCloudCalibrationDataDto(value)) {
        return PtwCloudCalibrationDataDtoToJSON(value as PtwCloudCalibrationDataDto);
    }

    return {};
}

/**
 * Check if a given object implements the CalibrationDataOverviewDtoNewDownloadedCalibration interface.
 */
export function instanceOfCalibrationDataOverviewDtoNewDownloadedCalibration(value: any): value is CalibrationDataOverviewDtoNewDownloadedCalibration {
    if (instanceOfPtwCloudCalibrationDataDto(value)) return true;
    return false;
}

